import { NgModule } from '@angular/core'
import { VarDirective } from './directives/ng-var.directive'
import { FileSizePipe } from './pipes/file-size.pipe'
import {
  LocalizedDatePipe,
  LocalizedDateTimePipe,
  LocalizedTimePipe,
  LocalizedValuePipe,
} from './pipes/localized-date.pipe'
import { HashDirective } from './directives/hash.directive'
import { AutofocusDirective } from './directives/autofocus.directive'

@NgModule({
  imports: [
    AutofocusDirective,
    LocalizedValuePipe,
    LocalizedDatePipe,
    LocalizedTimePipe,
    LocalizedDateTimePipe,
    FileSizePipe,
    HashDirective,
    VarDirective,
  ],
  declarations: [],
  exports: [
    LocalizedValuePipe,
    LocalizedDatePipe,
    LocalizedTimePipe,
    LocalizedDateTimePipe,
    FileSizePipe,
    HashDirective,
    VarDirective,
    AutofocusDirective,
  ],
})
export class SharedUtilsModule {}
